module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Shield-protected-40fdda5f467e86a1b38b9ee569cb7f4f.svg";